export default __webpack_public_path__ + "static/footer2025-542a0d32225a62ac418df81813a0a8b2.jpg";